import React from 'react';

import Box from '@mui/material/Box';

import ArticleOutlined from '@mui/icons-material/ArticleOutlined';

import { useTranslation } from 'react-i18next';
import { Message } from '@omnigenbiodata/ui';

import PortalLayout from '../../../../layout/Portal';
import CONTENT from '../../../../core/constants/content.constant';
import ParticipantInfo from '../../../../components/content/ParticipantInfo';
import { PISVersionSelector } from '../../../../store/participant/selectors';
import { useAppSelector } from '../../../../store';
import { chartColours } from '../../../../core/constants/colours.constants';
import PageContainer from '../../../../components/content/PageContainer';

function InformationScene() {
  const { t } = useTranslation('portal');
  const PISVersion = useAppSelector(PISVersionSelector);
  return (
    <PortalLayout>
      <PageContainer
        title={t('information.title')}
        icon={
          <Box
            sx={{
              width: 54,
              height: 54,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: `${chartColours[0]}26`,
              color: chartColours[0],
              flexShrink: 0,
              border: 1,
              borderColor: `${chartColours[0]}55`,
            }}
          >
            <ArticleOutlined sx={{ fontSize: 34 }} />
          </Box>
        }
      >
        {!PISVersion && (
          <Box
            data-testid="pis-message"
            sx={{
              mb: 3,
              '& > *': {
                borderRadius: 3,
              },
            }}
          >
            <Message severity="info">
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box>
                  {t('information.message.line1')}
                  <br />
                  <br />
                  {t('information.message.line2')}
                  <br />
                  <br />
                  {t('information.message.line3')}
                </Box>
              </Box>
            </Message>
          </Box>
        )}

        <ParticipantInfo
          address={CONTENT.STUDY_ADDRESS}
          web={CONTENT.MICROSITE_URL}
          email={CONTENT.STUDY_EMAIL}
          telephone={CONTENT.STUDY_TEL}
          version={PISVersion}
        />
      </PageContainer>
    </PortalLayout>
  );
}

export default InformationScene;
